<template>
    <div class="login">
        <div class="login__container">
            <div class="login__box">
                <form @submit.prevent="submitForm">
                    <div class="">
                        <img class="" src="../assets/logo.svg">
                    </div>
                    <div class="login__box__box_error">{{ error }}</div>
                    <div class="">
                        <input class="" v-model.trim="$v.login.email.$model" v-bind:placeholder="$t('login.email')"/>
                        <div class="login__box__validator_error" v-if="submitted && !$v.login.email.required">{{ $t('login.errors.email_required') }}</div>
                        <div class="login__box__validator_error" v-if="submitted && !$v.login.email.email">{{ $t('login.errors.email_not_formatted') }}</div>
                    </div>
                    <div class="">
                        <input type="password" v-model.trim="$v.login.password.$model" v-bind:placeholder="$t('login.password')"/>
                        <div class="login__box__validator_error" v-if="submitted && !$v.login.password.required">{{ $t('login.errors.password_required') }}</div>
                    </div>
                    <button type="submit" class="btn" :disabled="loading">
                        <span v-if="loading">{{ $t('login.buttonTitleLoading') }}</span> <span v-if="!loading">{{ $t('login.buttonTitle') }}</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import {required, email} from 'vuelidate/lib/validators'

    export default {
        name: 'login',
        components: {},
        data() {
            // pulisco la local storage
            localStorage.removeItem('token');
            return {
                submitted: false,
                error: '',
                loading: false,
                login: {
                    email: '',
                    password: ''
                }
            };
        },
        validations: {
            login: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            }
        },
        methods: {
            submitForm() {
                this.$v.$touch();
                this.submitted = true;
                this.error = '';
                this.loading = true;
                if (!this.$v.$invalid) {
                    this.api.login(this.login.email, this.login.password)
                        .then(() => {
                            let toPath = '/';
                            if (this.$route.query.redirectFrom) {
                                toPath = this.$route.query.redirectFrom;
                            }
                            this.$router.push(toPath).catch(() => {
                            });
                        })
                        .catch(error => {
                            this.error = this.$t(`login.errors.${error.error}`);
                            this.login.password = '';
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                } else {
                    this.loading = false;
                }
            }
        }
    }
</script>
